export default __webpack_public_path__ + "static/media/collect-directly.08226462.jpeg";